import { useEffect } from 'react';

// Face toate popup-urile (.modal) mutabile pe ecran, tinand click apasat pe
// header-ul lor (.modal-header) si tragand. Implementat o singura data, global,
// prin delegare de evenimente pe document - functioneaza automat pentru orice
// popup din aplicatie (Miscari, Materiale, Produse, Comenzi etc.), fara sa fie
// nevoie sa modificam fiecare pagina in parte.
export default function DraggableModals() {
  useEffect(() => {
    let dragState = null;

    function onMouseDown(e) {
      const header = e.target.closest('.modal-header');
      if (!header) return;
      if (e.target.closest('.modal-close')) return; // butonul X nu porneste drag-ul
      const modal = header.closest('.modal');
      if (!modal) return;

      const rect = modal.getBoundingClientRect();
      // La primul drag, scoatem modalul din centrarea flex si il fixam la
      // pozitia lui curenta, ca sa nu sara vizual in momentul in care incepem.
      modal.style.position = 'fixed';
      modal.style.left = rect.left + 'px';
      modal.style.top = rect.top + 'px';
      modal.style.margin = '0';

      dragState = {
        modal,
        startX: e.clientX,
        startY: e.clientY,
        origLeft: rect.left,
        origTop: rect.top
      };
      header.style.cursor = 'grabbing';
      e.preventDefault();
    }

    function onMouseMove(e) {
      if (!dragState) return;
      const dx = e.clientX - dragState.startX;
      const dy = e.clientY - dragState.startY;
      let left = dragState.origLeft + dx;
      let top = dragState.origTop + dy;
      // Nu lasam popup-ul sa iasa complet din ecran.
      left = Math.max(-dragState.modal.offsetWidth + 80, Math.min(left, window.innerWidth - 80));
      top = Math.max(0, Math.min(top, window.innerHeight - 40));
      dragState.modal.style.left = left + 'px';
      dragState.modal.style.top = top + 'px';
    }

    function onMouseUp() {
      if (dragState) {
        const header = dragState.modal.querySelector('.modal-header');
        if (header) header.style.cursor = '';
      }
      dragState = null;
    }

    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  return null;
}
